import { Link } from "react-router-dom";

export function Footer({ supportEmail }: { supportEmail?: string }) {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand" aria-label="ReleaseMachine home">
              <span className="brand-mark" aria-hidden="true" />
              ReleaseMachine
            </Link>
            <p>AI-generated marketing campaigns for independent artists.</p>
          </div>
          <div className="footer-col">
            <h4>Product</h4>
            <nav aria-label="Product">
              <Link to="/#how-it-works">How it works</Link>
              <Link to="/#pricing">Pricing</Link>
              <Link to="/build">Build My Campaign</Link>
            </nav>
          </div>
          <div className="footer-col">
            <h4>Resources</h4>
            <nav aria-label="Resources">
              <Link to="/#faq">FAQ</Link>
            </nav>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <nav aria-label="Legal">
              <Link to="/privacy">Privacy</Link>
              <Link to="/terms">Terms</Link>
              <Link to="/refunds">Refunds</Link>
              {supportEmail ? (
                <a href={`mailto:${supportEmail}`}>Contact support</a>
              ) : null}
            </nav>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} ReleaseMachine. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
